import cn from "classnames";
import { useTranslation } from "react-i18next";

import CrossIcon from "assets/icons/cross.svg?react";

import { InvestObjectsHeaderProps } from "./InvestObjectsHeader.types";

import {
  MAX_PARKINGS_LIMIT,
  MAX_APARTMENTS_LIMIT,
  CALCULATOR_OBJECT_TYPES,
  CALCULATOR_TYPES,
} from "constants/calculator";

import { getParkingTypeName } from "./InvestObjectsHeader.helpers";

import { Typography } from "shared/ui/components/Typography";

import { AddObjectButton } from "../AddObjectButton";

import styles from "./InvestObjectsHeader.module.scss";

const InvestObjectsHeader = ({
  values,
  activeObject,
  calculatorType,
  onObjectClick,
  onAddObjectClick,
  onObjectRemoveClick,
}: InvestObjectsHeaderProps) => {
  const { t } = useTranslation();

  const isStandard = calculatorType === CALCULATOR_TYPES.BASIC;
  const isPro = calculatorType === CALCULATOR_TYPES.STANDARD || calculatorType === CALCULATOR_TYPES.EXPERT;
  const activeObjectType = activeObject?.type;
  const activeObjectIndex = activeObject?.index;

  if (isStandard) {
    return null;
  }

  return (
    <div className={styles.root}>
      {values.apartments.map((apartment: any, index: number) => (
        <div
          key={`apartment-${apartment.id ?? index}`}
          className={cn(styles.item, {
            [styles.itemActive]:
              activeObjectType === CALCULATOR_OBJECT_TYPES.APARTMENT &&
              activeObjectIndex === index,
          })}
          onClick={() =>
            onObjectClick(CALCULATOR_OBJECT_TYPES.APARTMENT, index)
          }
        >
          <Typography variant="bodyS">
            {t("calculator_form.invest_objects.apartment")}
          </Typography>
          {index !== 0 && isPro && (
            <div className={styles.iconWrapper}>
              <CrossIcon
                onClick={(e) => {
                  e.stopPropagation();
                  onObjectRemoveClick(CALCULATOR_OBJECT_TYPES.APARTMENT, index);
                }}
                className={styles.itemCrossIcon}
              />
            </div>
          )}
        </div>
      ))}
      {values.parkings.map((parking: any, index: number) => (
        <div
          key={`parking-${parking.id ?? index}`}
          className={cn(styles.item, {
            [styles.itemActive]:
              activeObjectType === CALCULATOR_OBJECT_TYPES.PARKING &&
              activeObjectIndex === index,
          })}
          onClick={() => onObjectClick(CALCULATOR_OBJECT_TYPES.PARKING, index)}
        >
          <Typography variant="bodyS">
            {getParkingTypeName(parking.parkingType, t)}
          </Typography>
          {isPro && (
            <div className={styles.iconWrapper}>
              <CrossIcon
                onClick={(e) => {
                  e.stopPropagation();
                  onObjectRemoveClick(CALCULATOR_OBJECT_TYPES.PARKING, index);
                }}
                className={styles.itemCrossIcon}
              />
            </div>
          )}
        </div>
      ))}
      {
        (
          values.apartments.length < MAX_APARTMENTS_LIMIT ||
          values.parkings.length < MAX_PARKINGS_LIMIT
        ) &&
        isPro && <AddObjectButton onAddObjectClick={onAddObjectClick} />
      }
    </div>
  );
};

export default InvestObjectsHeader;
